import { useAuth } from "../context/AuthProvider";
import { Link } from "react-router-dom";
import React, { useState } from 'react';
import DeleteModal from '../cors/DeleteModal'; 
import { toast } from 'sonner';
import { BASE_URL } from '../apiConfig';


export default function VariantCard({ variant, getTypeColor, fetchVariants }) {
  const { token, role, roles } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteVariant = async () => {
    setIsModalOpen(false); 

    try {
      const res = await fetch(BASE_URL+`/api/variants/${variant.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success("Suppression réussie");
        fetchVariants();
      } else {
        const err = await res.json()
        toast.error("Échec de la suppression");
      }
    } catch (error) {
      toast.error("Échec de la suppression");
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  const isColor = (value) => {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value)
  }

  const renderValue = () => {
    if (isColor(variant.value)) {
      return (
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-full border-2 border-gray-200 shadow-sm"
            style={{ backgroundColor: variant.value }}
          />
          <span className="font-mono text-sm text-gray-600">{variant.value}</span>
        </div>
      )
    }
    return (
      <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm font-medium">
        {variant.value}
      </span>
    )
  }

  return (
    <>
      <div className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
        {/* Header */}
        <div className="p-4 border-b border-gray-100">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-bold text-gray-900 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
                  {variant.name}
                </h3>
                <span className={`px-2 py-1 rounded-full text-[10px] font-semibold ${getTypeColor(variant.type)}`}>
                  {variant.type.toUpperCase()}
                </span>
              </div>
            </div>
          </div>

  
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-2">VALUE</label>
            {renderValue()}
          </div>
        </div>

        {/* Actions */}
        <div className="p-4">
          <div className="flex justify-between max-xl:justify-end gap-2">
              <div className="flex items-center text-[10px] text-gray-500 max-xl:hidden">
              <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Dernière mise à jour: {formatDate(variant.updated_at)}
            </div>
            <div className="flex gap-2">
              {
                (role === 1 || (role === 2 && roles.edit_variant === 1)) &&
                  <Link to={`/variants/update/${variant.id}`}>
                    <button className="p-2 cursor-pointer border-2 border-gray-200 hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300">
                      <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </button>
                  </Link>
              }
              {
                (role === 1 || (role === 2 && roles.delete_variant === 1)) &&
                <button
                    onClick={() => setIsModalOpen(true)} 
                    className="p-2 cursor-pointer border-2 border-gray-200 hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
                >
                  <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2
                      2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
                      1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={deleteVariant}
        title="Delete Variant"
        message="Are you sure you want to delete the variant?"
        itemName={variant.name}
      />
    </>
  )
}